/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const SUCCESS_PATH = 'success';
export const RAN_SUCCESSFULLY = 'Ran successfully';

/**
 * Default number of milliseconds before a form should regresh and
 * re-trigger its validation.
 */
export const DEFAULT_FORM_DEBOUNCE_DELAY = 100;

// Constant to hold the max char count value allowed for password fields
export const MAX_PASSWORD_LENGTH = 512;
